import {PaletteColorsEnum} from '../styles/paletteModel';
import {UserTheme} from './themeTypes';

export type PaletteColorShadeFinder = (theme: UserTheme, color: PaletteColorsEnum) => string;

// Convenience methods for looking up a shade by PaletteColorEnum. Useful with
// semantic styles if you need to support multiple palette colors (see tagSemanticStyles.)
export const findColorShade10: PaletteColorShadeFinder = (theme, color) => theme.palette[color].shade10;
export const findColorShade20: PaletteColorShadeFinder = (theme, color) => theme.palette[color].shade20;
export const findColorShade30: PaletteColorShadeFinder = (theme, color) => theme.palette[color].shade30;
export const findColorShade40: PaletteColorShadeFinder = (theme, color) => theme.palette[color].shade40;
export const findColorShade50: PaletteColorShadeFinder = (theme, color) => theme.palette[color].shade50;
